<template>
    <div v-if="bannerList.length" class="static-banners">
        <div v-for="banner in bannerList" :key="banner.alt" class="static-banner-wrapper">
            <a :href="banner.url" class="d-block text-center">
                <picture v-if="banner.mobileImage?.length && banner.desktopImage.length">
                    <source media="(min-width: 480px)" :srcset="banner.desktopImage" />
                    <img class="banner-img" :src="banner.mobileImage" width="590" height="365" :alt="banner.alt" loading="lazy" />
                </picture>

                <img v-else :src="banner.desktopImage" width="590" height="365" :alt="banner.alt" loading="lazy" />
            </a>
        </div>
    </div>
</template>

<script lang="ts">
import { PropType } from 'vue'
import HomepageStaticBanner from '~/models/HomepageStaticBanner'

export default {
    props: {
        bannerList: {
            type: Array as PropType<HomepageStaticBanner[]>,
            required: false,
            default: () => [],
        },
    },
}
</script>

<style scoped lang="scss">
.static-banners {
    max-width: 1392px;
    margin: auto;
    display: flex;
    gap: 15px;
    flex-direction: column;

    .static-banner-wrapper {
        flex: 1;
    }

    @media (min-width: 678px) {
        flex-direction: row;
    }

    .banner-img {
        width: 100%;
    }

    .pl-5 {
        padding-left: 0.5rem;
    }

    .pr-5 {
        padding-right: 0.5rem;
    }
}
</style>
